import React from 'react';

const LocalSeoBanner = () => (
  <div className="bg-gradient-to-r from-olive/10 to-gold/10 border-y border-gold/20">
    <div className="max-w-7xl mx-auto px-4 py-3 text-sm text-gray-700 flex flex-wrap gap-x-4 gap-y-1 justify-center">
      <span>Gauteng event services near me</span>
      <span>Reliable service in Pretoria, Centurion, Midrand, Johannesburg</span>
      <span>Limited availability - weekend bookings fill fast</span>
      <span>Experienced team and full-service event solutions</span>
    </div>
  </div>
);

export default LocalSeoBanner;
